module.exports = __webpack_public_path__ + "img/Steel-Mug.a01f6a41.svg";